export default __webpack_public_path__ + "static/media/coffee-cup-tablet.a3182264.png";